module.exports = "img/flags/MQ.8d85548.png";